/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppAuthorizedDomains = () => apiClient.get('/authorized-domains');
export const getAppAuthorizedDomainById = (id) => apiClient.get(`/authorized-domains/${id}`);
export const updateAppAuthorizedDomain = (id, data) => apiClient.put(`/authorized-domains/${id}`, data);
export const validateAppAuthorizedDomainAdmin = (id, adminEmail) => apiClient.post(`/authorized-domains/${id}/validate-admin`, { adminEmail });
